<template>
  <router-view
    :viewPermission="viewPermission"
    :createPermission="createPermission"
    :editPermission="editPermission"
    :deletePermission="deletePermission"
  />
</template>
<script>
import { mapState } from 'vuex'
import accessMix from '@/services/accessmix.js'
export default {
  mixins: [accessMix],
  computed: {
    ...mapState(['user']),
    viewPermission() {
      return this.checkPermissions(this.user.permissions, 'custom-pages', 'view')
    },
    createPermission() {
      return this.checkPermissions(this.user.permissions, 'custom-pages', 'create')
    },
    editPermission() {
      return this.checkPermissions(this.user.permissions, 'custom-pages', 'edit')
    },
    deletePermission() {
      return this.checkPermissions(this.user.permissions, 'custom-pages', 'delete')
    },
  },
}
</script>
